import React, { FC } from 'react';
import Teams from '../../../../assets/images/icons/integrations/ic-integration-teams.svg';
import Linear from '../../../../assets/images/icons/integrations/ic-integration-linear.svg';
import cx from 'classnames';
import styles from './index.module.css';
import type { SvgIconComponent } from './integrationsInfo';

type Props = {
  show?: boolean;
  mobileView?: boolean;
  name: string;
  icon?: string | SvgIconComponent;
  integrationName: string;
};

export const IntegrationIcon: FC<Props> = ({
  show = true,
  mobileView,
  name,
  icon,
  integrationName
}) => {
  if (!show) return null;
  const SvgComponent = typeof icon === 'function' ? (icon as SvgIconComponent) : null;

  return (
    <span
      className={cx(`integration-icon icon-${name}`, styles.integrationIcon, {
        [styles.mobileIconView]: mobileView
      })}
    >
      {integrationName === 'teams' ? (
        <Teams className={styles.teamsIcon} />
      ) : integrationName === 'linear' ? (
        <Linear className={styles.linearIcon} />
      ) : SvgComponent ? (
        <SvgComponent className={styles.integrationIconImage} />
      ) : (
        icon && (
          <img
            className={styles.integrationIconImage}
            src={icon as string}
            alt={`icon-${integrationName}`}
          />
        )
      )}
    </span>
  );
};
